import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from '@redux';
import { receivedTransferOrders } from '@redux/transferOrders/actions';
import { Button, Modal } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DynamicObjectType } from 'types/commons';

interface IReceivedModalProps {
  data: DynamicObjectType;
  onCancel: () => void;
  callback?: () => void;
}

const ReceivedModal = ({ data, onCancel, callback }: IReceivedModalProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const modal = useSelector<DynamicObjectType>((state) => state.modal.modal);

  const [loading, setLoading] = useState(false);

  const handleReceived = () => {
    setLoading(true);
    dispatch(
      receivedTransferOrders({
        data: {
          id: data?.id,
        },
        options: {
          isShowSuccessNoti: true,
        },
      }),
    ).then((res: DynamicObjectType) => {
      setLoading(false);
      if (res?.payload?.success) {
        onCancel();
        if (callback) {
          callback();
        } else navigate(`/transfer-orders?status=RECEIVED`);
      }
    });
  };

  return (
    <Modal
      open={modal?.received?.isOpen}
      onCancel={onCancel}
      footer={null}
      width={443}
      closeIcon={false}
      closable={false}
    >
      <div className="grid gap-5">
        <div className="text-center text-[24px]">
          <FontAwesomeIcon
            icon={faCircleExclamation}
            className="text-[--primary] mb-[5px]"
          />
          <div className="text-center text-base font-semibold">
            {t('transferOrders.confirmReceived')}
          </div>
        </div>
        <div className="text-center text-[#53575D] text-sm">
          {t('transferOrders.confirmActionDescription')}
        </div>
        <div className="flex justify-center items-center gap-2.5">
          <Button className="h-[40px] w-[100px]" onClick={onCancel}>
            {t('button.cancel')}
          </Button>
          <Button
            className="h-[40px] w-[100px]"
            type="primary"
            onClick={handleReceived}
            loading={loading}
          >
            {t('button.ok')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ReceivedModal;
